ConnectStore = require 'components/enhancers/connect_store'
DynamicHeightContainer = require 'components/common/dynamic_height_container'
{ get, kebabCase, snakeCase } = require 'lodash'
{ MDA_HANDOUT } = require 'lib/db_docs/doc_types'
MdaTopicsStore = require 'stores/mda_topics_store'
QuestionsStore = require 'stores/questions_store'
QuestionsStatusesStore = require 'stores/questions_statuses_store'
{ useCoffeeMemo, useI18n } = require 'lib/react_utils'
{ useState } = React

storeConnector =
  MdaTopicsStore: (Store) ->
    topics: Store.getTopics()
  QuestionsStore: (Store) ->
    handouts: Store.getQuestions(MDA_HANDOUT)
  QuestionsStatusesStore: (Store) ->
    questionStatuses: Store.getQuestionsStatuses()

# value will be the topic id
TopicSelectorField = ({ renderOption, topics }) ->

  i18n = useI18n('mda:handouts')

  <div className="topic-selector-field">
    <ul className="topic-selector-field__options">
      {topics.size is 0 and <li>{i18n 'no_topics_available'}</li>}
      {topics.map (topic) -> renderOption(topic)}
    </ul>
  </div>

TopicSelectorFieldForHandoutCreation = ({ data, handouts, onChange, topics, questionStatuses }) ->

  data = if data? then data else {}
  value = get data, 'options.parentTopicId'

  topicIdsWithHandouts = useCoffeeMemo [handouts], ->
    handouts.reduce (acc, doc) ->
      parentTopicId = doc.getIn(['options', 'parentTopicId'])
      if parentTopicId
        acc.add parentTopicId
      else
        acc
    , Immutable.Set()

  filteredTopics = useCoffeeMemo [topics, topicIdsWithHandouts, questionStatuses], ->
    topics.filter (topic) ->
      topicId = topic.get('_id')
      hasHandoutInCurrentProject = topicIdsWithHandouts.has(topicId)
      topicHasBeenExcludedFromHandoutGeneration = questionStatuses.getIn([topicId, 'handoutExcluded', 'status'], false)
      topicIsDone = questionStatuses.getIn([topicId, 'mdaTopicsStatus', 'status']) in ['done', 'doneDR']
      topicIsDone and not hasHandoutInCurrentProject and not topicHasBeenExcludedFromHandoutGeneration

  topicViaTableConnections = useCoffeeMemo [topics], ->
    topicsByTableId = topics.reduce (acc, topic) ->
      topic.get('insertedTables', Immutable.List()).reduce (tableAcc, tableId) ->
        tableAcc.update(tableId, Immutable.Set(), (topicsForTable) -> topicsForTable.add(topic))
      , acc
    , Immutable.Map()

    topics.reduce (acc, topic) ->
      topicId = topic.get('_id')
      topicsWithSharedTables = topic.get('insertedTables', Immutable.List()).reduce((connectedAcc, tableId) ->
        topicsByTableId.get(tableId, Immutable.List()).reduce (tableConnectedAcc, connectedTopic) ->
          connectedTopicId = connectedTopic.get('_id')
          if connectedTopicId isnt topicId
            tableConnectedAcc.set(connectedTopicId, connectedTopic)
          else
            tableConnectedAcc
        , connectedAcc
      , Immutable.OrderedMap()).valueSeq().toList()

      acc.set(topicId, topicsWithSharedTables)
    , Immutable.Map()

  renderTopic = (topic) ->
    topicId = topic.get('_id')

    <li key={topicId} className="flex items-center w-full">
      <TopicSelectorItem
        topic={topic}
        topicId={topicId}
        topicsConnectedViaTables={topicViaTableConnections.get(topicId, Immutable.List())}
        questionStatuses={questionStatuses}
        onChange={onChange}
        value={value}
      />
    </li>

  <TopicSelectorField
    value={value}
    onChange={onChange}
    topics={filteredTopics}
    renderOption={renderTopic}
  />

TopicSelectorItem = ({ topic, topicId, topicsConnectedViaTables, questionStatuses, value, onChange }) ->
  [ showConnectedTopics, setShowConnectedTopics ] = useState(false)

  toggleShowConnectedTopics = ->
    setShowConnectedTopics((current) -> not current)

  <div className="w-full">
    <div className={"flex items-center justify-between gap-5 #{if showConnectedTopics then 'mb-5' else ''}"}>
      <label className="flex items-center gap-5">
        <input
          type="radio"
          name="topic"
          value={topicId}
          onChange={() -> onChange(topic)}
          checked={value is topicId}
        />
        <span>{topic.get('name')}</span>
      </label>
      {topicsConnectedViaTables.size > 0 and <button className="cursor-pointer" onClick={toggleShowConnectedTopics}>
        <svg width="20" height="20" viewBox="0 0 20 20" className="inline mt-5">
          <polygon points="10,2 18,18 2,18" fill="none" stroke="currentColor" strokeWidth="1" />
          <text x="10" y="15" textAnchor="middle" fontSize="9" fontWeight="bold" fill="currentColor">{topicsConnectedViaTables.size}</text>
        </svg>
      </button>}
    </div>

    {topicsConnectedViaTables.size > 0 and <DynamicHeightContainer>
      {showConnectedTopics and <div className="connected-topics pt-5">
        <ul className="m-0 ml-20 pl-0">
          {topicsConnectedViaTables.map (connectedTopic) ->
            <ConnectedTopic
              key={connectedTopic.get('_id')}
              connectedTopic={connectedTopic}
              questionStatuses={questionStatuses}
            />
          }
        </ul>
      </div>}
    </DynamicHeightContainer>}
  </div>

ConnectedTopic = ({ connectedTopic, questionStatuses }) ->
  i18n = useI18n('es:question.statuses')
  status = questionStatuses.getIn([connectedTopic.get('_id'), 'mdaTopicsStatus', 'status'])
  <li className="w-full flex flex-row items-center justify-between gap-10 pl-10 mb-5" key={connectedTopic.get('_id')}>
    <span>{connectedTopic.get('name')}</span>
    {!_.isEmpty(status) and <span className={"text-center module-progress__box module-progress__box--#{kebabCase(status)}"}>
      {i18n("status.#{snakeCase(status)}")}
    </span>}
  </li>

module.exports = {
  TopicSelectorFieldForHandoutCreation: ConnectStore TopicSelectorFieldForHandoutCreation, [MdaTopicsStore, QuestionsStore, QuestionsStatusesStore], storeConnector
}
